import Vue from "vue";
Vue.filter("pluralize", (value, word) => {
  return value > 1 ? `${value} ${word}s` : `${value} ${word}`;
});
